import { IIconProps } from "./types"

export default function IconVec8(props: IIconProps) {
  const width = props.size || props.width || 37
  const height = props.size || props.height || 26
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 37 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.9043 10.7285C33.8166 14.3681 33.9267 16.7936 31.2891 19.2424"
        stroke="#3A3939"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.1988 12.9029L36.0234 12.4772L32.4351 8.86328L30.7578 13.6776L32.5983 13.2647L34.1988 12.9029Z"
        fill="#3A3939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.74875 19.3089C6.08932 19.1073 10.4139 18.9088 14.8409 18.2078C19.2679 17.5068 23.7813 16.3192 26.0444 15.7206C28.2947 15.1188 28.2947 15.1189 28.2947 15.1189L27.6065 10.7559L1.06055 14.9428L1.74875 19.3089Z"
        fill="#3A3939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1958 4.81691C22.8296 4.33036 18.4667 3.84375 13.9404 3.84375C9.4014 3.84375 4.69911 4.33034 2.34957 4.58002C2.80469e-05 4.81689 0 4.81691 0 4.81691V9.34314H27.1958V4.81691Z"
        fill="#CCCCCC"
      />
    </svg>
  )
}
